<template>

  <div class="corpo-pagina">

    <div class="row row-text">
      <div class="col s12">
        <h4>{{ this.translation.getters.traduzione('forgot.passwor.ask') }}</h4>
      </div>
    </div>

    <div class="divider"></div>

    <div class="row">
      <div class="col s12 m7 l7">
        <form class="col s12 filed-box">
          <div>
            <div class="input-field">
              <i class="material-icons prefix">email</i>
              <input type="text" v-model="form.username" class="validate" id="username" autocomplete="off">
              <label for="username">{{ this.translation.getters.traduzione('field.account.email') }}</label>
              <span id="error-message-username" class="error-message-style nodipslay">
                  {{ this.translation.getters.traduzione('filed.required.validation') }}
              </span>
            </div>
          </div>
        </form>
      </div>
      <div class="col s12 m5 l5"></div>
    </div>

    <div class="row">
      <div class="col s12 m4 l4">
        <span id="credencial-error" class="error-message-style nodipslay" style="font-size: 20px!important;">
                  {{ this.translation.getters.traduzione('filed.email.validation') }}
        </span>
      </div>
      <div class="col s12 m8 l8"></div>
    </div>

    <div class="row">
      <div class="col s12 m4 l4">

        <a class="btn-large" @click="sendMailResetPassword()">
          <i class="material-icons left">security</i>
          {{ this.translation.getters.traduzione('bt.reset.password') }}
        </a>
      </div>
      <div class="col s12 m8 l8"></div>
    </div>

  </div>

</template>
<script>

import apiService from '@/services/apiService.js'
import translationStore from '@/store/translations'
import loadingStore from '@/store/loading'

export default {
  data () {
    return {
      form: { username: '', message_mail: { title: '', message: '', subject: '', btn: '' } },
      translation: translationStore,
      msg: false

    }
  },
  methods: {

    async validateForm () { return true },

    async sendMailResetPassword () {
      loadingStore.commit('setLoading', true)
      const valid = await this.validateForm()
      const msg = document.getElementById('credencial-error')
      msg.classList.add('nodipslay')

      if (valid) {
        try {
          const token = await apiService.getClientCredentialsToken()
          if (!token) {
            this.$router.push('/error')
          } else {
            this.form.message_mail.title = this.translation.getters.traduzione('title.reset.password')
            this.form.message_mail.message = this.translation.getters.traduzione('msr.reset.password.mail')
            this.form.message_mail.subject = this.translation.getters.traduzione('subject.mail.resetpassword')
            this.form.message_mail.btn = this.translation.getters.traduzione('btn.reset.password.mail')

            const url = process.env.VUE_APP_URL_USER + '/user/resetpassword'
            const json = await apiService.sendRequestWithBearer('POST', url, token, this.form)

            if (!json) {
              if (msg) {
                msg.classList.remove('nodipslay')
              }
            } else {
              this.$router.push('/recover-password-email/finish')
            }
          }
        } catch (error) {
          this.$router.push('/error')
        }
      }
    }
  },

  mounted () {
    document.addEventListener('DOMContentLoaded', function () {
      const passwordInput = document.getElementById('password')
      const passwordToggle = document.querySelector('.password-toggle')

      if (passwordToggle) {
        passwordToggle.addEventListener('click', function () {
          const type = passwordInput.getAttribute('type') === 'password' ? 'text' : 'password'
          passwordInput.setAttribute('type', type)
          this.querySelector('i').textContent = type === 'password' ? 'visibility' : 'visibility_off'
        })
      }
    })

    loadingStore.commit('setLoading', false)
  }

}
</script>
<style>
.input-field {
  position: relative;
  /* Rende il contenitore un punto di riferimento per il posizionamento assoluto */
}

.password-toggle {
  position: absolute;
  top: 50%;
  right: 10px;
  /* Regola la distanza dal bordo destro */
  transform: translateY(-50%);
  /* Centra verticalmente l'icona */
  cursor: pointer;
  /* Indica che è cliccabile */
  user-select: none;
  /* Impedisce la selezione del testo dell'icona */
}

.password-toggle i {
  color: #757575;
  /* Colore dell'icona (grigio medio) */
}
</style>
